import { createRouter, createWebHistory } from "vue-router";
// General Views
import NotFound from "../project/NotFoundPage.vue";
import Session from "../project/Session.vue";
import AccessDenied from "../project/AccessDenied.vue";
// Layout
import DashboardLayout from "../examples/PageLayout/DashboardLayout.vue";
import SubrogationPayment from "@/project/Components/Payment.vue";
import SubrogationForm from "@/project/Subrogations/Components/SubrogationForm.vue";
import SubrogationMain from "@/project/NewSubrogationCases/Main.vue";
import HomePage from "@/project/Dashboard/Home.vue";
import SubrogationList from "@/project/Subrogations/Components/SubrogationList.vue";
import PreCourtDetails from "@/project/PreCourt/Components/PreCourtDetails.vue";
import EnforcementPayment from "@/project/Enforcement/Components/EnforcementPayment.vue";
import CourtPreparationForm from "@/project/CourtPreparation/Components/CourtPreparationForm.vue";
import CalendarJournal from "@/project/Components/CalendarJournal.vue";
import DebtorJournal from "../project/Components/DebtorJournal.vue";
import WarningJournal from "../project/Components/WarningJournal.vue";
import Court from "@/project/Court/Components/Court.vue";

const routes = [
  {
    path: "/court/:subrogationId/:courtCaseId?",
    name: "Court",
    component: Court,
    props: true,
    meta: { requiresAuth: true }
  },

  {
    path: "/session/:id?",
    name: "Session",
    props: true,
    component: Session,
  },
  {
    path: "/accessdenied",
    name: "AccessDenied",
    component: AccessDenied,
  },

  {
    path: "/",
    component: DashboardLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        redirect: "/home",
        meta: {
          requiresAuth: true,
          role: [
            "Call center operator",
            "Accident commissar operator",
            "Client service operator",
            "Tech expertise operator",
            "Legal operator",
            "Approval operator",
            "Payment viewer",
          ],
        }
      },
      {
        path: "home",
        name: "Ana səhifə",
        component: HomePage,
        meta: { requiresAuth: true },
      },
      // Dashboard
      {
        path: "dashboard",
        name: "Dashboard",
        component: SubrogationMain,
        meta: {
          requiresAuth: true,
          role: [
            "Call center operator",
            "Accident commissar operator",
            "Client service operator",
            "Tech expertise operator",
            "Legal operator",
            "Approval operator",
            "Payment viewer",
          ],
        },
      },

      // Subrogation
      {
        path: "subrogation",
        name: "Subroqasiya - Main",
        component: SubrogationMain,
        meta: {
          requiresAuth: true,
          role: ["Accident commissar operator", "Accident commissar viewer", "Accident commissar manager"],
        },
      },
      {
        path: "subrogation/list",
        name: "Subroqasiya - Siyahı",
        component: SubrogationList,
        meta: {
          requiresAuth: true,
          role: ["Accident commissar operator", "Accident commissar viewer", "Accident commissar manager"],
        },
      },
      {
        path: "subrogation/form/:id?",
        name: "Subroqasiya - Məlumat",
        props: true,
        component: SubrogationForm,
        meta: {
          requiresAuth: true,
          role: ["Client service manager", "Client service operator", "Client service viewer"],
        },
      },
      {
        path: "subrogation/:id?",
        name: "Subroqasiya - Ödəniş",
        props: true,
        component: SubrogationPayment,
        meta: {
          requiresAuth: true,
          role: ["Accident commissar operator", "Accident commissar viewer", "Accident commissar manager"],
        },
      },
      {
        path: "subrogation/payment/:subrogationId/:participantId",
        name: "EnforcementPayment",
        props: true,
        component: EnforcementPayment,
        meta: {
          requiresAuth: true,
          role: ["Accident commissar operator", "Accident commissar manager"],
        },
      },

      // Search
      {
        path: "search",
        name: "Axtarış - Main",
        component: SubrogationMain,
        meta: {
          requiresAuth: true,
          role: ["Chairman", "Assistant Chairman", "Advisor", "Director of ICD", "Assistant Director of ICD", "Payment manager", "Payment viewer"],
        },
      },

      {
        path: "subrogation/precourt/:subrogationId/:participantId",
        name: "SubrogationPreCourtDetails",
        props: true,
        component: PreCourtDetails,
        meta: {
          requiresAuth: true,
          role: [
            "Legal operator",
            "Approval operator",
          ],
        },
      },
      {
        path: "court-preparation/:subrogationId/:participantId",
        name: "CourtPreparationForm",
        props: true,
        component: CourtPreparationForm,
        meta: {
          requiresAuth: true,
          role: [
            "Legal operator",
            "Approval operator",
          ],
        },
      },
      {
        path: "journal/calendar",
        name: "JournalCalendar",
        component: CalendarJournal,
        meta: { requiresAuth: true },
      },
      {
        path: "journal/debtors",
        name: "DebtorJournal",
        component: DebtorJournal,
        meta: { requiresAuth: true },
      },
      {
        path: "journal/warnings",
        name: "WarningJournal",
        component: WarningJournal,
        meta: { requiresAuth: true },
      },
    ],
  },

  // 404 Not Found
  { path: "/:pathMatch(.*)*", name: "NotFound", component: NotFound },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;